import { ComponentType } from '@angular/cdk/portal';
import { inject, Service, TemplateRef } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';

const ANIMATION_DURATION = 150;

@Service()
export class IdealsDialogService {
  readonly #matDialog = inject(MatDialog);

  open<T, D = unknown, R = unknown>(
    componentOrTemplateRef: ComponentType<T> | TemplateRef<T>,
    config?: MatDialogConfig<D>,
  ): MatDialogRef<T, R> {
    const dialogRef = this.#matDialog.open<T, D, R>(componentOrTemplateRef, config);

    this.#addAnimationOnClose(dialogRef);

    return dialogRef;
  }

  #addAnimationOnClose<T, R = unknown>(dialogRef: MatDialogRef<T, R>): void {
    const nativeClose = dialogRef.close;

    dialogRef.close = (dialogResult): void => {
      dialogRef.addPanelClass('fade');
      setTimeout(() => {
        nativeClose.call(dialogRef, dialogResult);
      }, ANIMATION_DURATION);
    };
  }
}
